import { render, staticRenderFns } from "./fuCardOrderDetail.vue?vue&type=template&id=527f3264&scoped=true"
import script from "./fuCardOrderDetail.vue?vue&type=script&lang=js"
export * from "./fuCardOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./fuCardOrderDetail.vue?vue&type=style&index=0&id=527f3264&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527f3264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('527f3264')) {
      api.createRecord('527f3264', component.options)
    } else {
      api.reload('527f3264', component.options)
    }
    module.hot.accept("./fuCardOrderDetail.vue?vue&type=template&id=527f3264&scoped=true", function () {
      api.rerender('527f3264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/fuCard/fuCardOrderDetail.vue"
export default component.exports